var path = 'views/preAuthTemplate.html';
var html = "<div id=\"preAuthTemplateOuter\">\n  <div id=\"preAuthContent\" ui-view=\"content\">\n    \n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/views/preAuthTemplate.html
// module id = 0IaA
// module chunks = 0